import React from 'react'
import PropTypes from 'prop-types'

const ResultItem = (props) => {
  const {
    object_type: objectType,
    object_id: objectId,
    selected_p: selected,
    onClick,
    token,
    title,
  } = props

  let className = `result-item result-item-${objectType}`
  if (selected) {
    className = `${className} selected`
  }
  return (
    <div className={className} onClick={onClick}>
      <div className="select-icon" />
      {/^(photo|live)/.test(objectType) && (
        <img
          className="thumbnail"
          src={`/thumbnail/${objectId}/${token}/120x80/thumbnail.jpg`}
          alt="Video thumnail"
        />
      )}
      <div className="title">{title}</div>
    </div>
  )
}

ResultItem.propTypes = {
  title: PropTypes.string.isRequired,
  selected_p: PropTypes.oneOf([0, 1]).isRequired,
  object_type: PropTypes.string.isRequired,
  object_id: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default ResultItem
